<template>
    <v-app app>
        <navigation-bar v-if="showNavigationBar"></navigation-bar>
        <app-bar v-if="showAppBar" @toggleNavigationBar="toggleNavigationBar" @toggleAgentBar="toggleAgentBar"></app-bar>
        <agent-bar v-if="showAgentBar"></agent-bar>
         <v-overlay :value="this.$store.state.loading" opacity="0.3" z-index=500>
            <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
        </v-overlay>
        <default-view />
    </v-app>
</template>

<script>
import AppBar from './AppBar.vue';
import NavigationBar from './NavigationBar.vue';
import AgentBar from './AgentBar.vue';
import DefaultView from './DefaultView.vue';
export default {
    components: {
        AppBar,
        NavigationBar,
        AgentBar,
        DefaultView
    },
    data() {
        return {
            showNavigationBar: false,
            showAgentBar: false,
            showAppBar: false
        }
    },
    watch: {
        $route(to) {
            this.showNavigationBar = to.meta.showNavigationBar ?? true;
            this.showAgentBar = to.meta.showAgentBar ?? true;
            this.showAppBar = to.meta.showAppBar ?? true;

            console.log('showAppBar: ' + to.meta.showAppBar);
        }
    },
    methods: {
        toggleNavigationBar() {
            this.showNavigationBar = !this.showNavigationBar;
        },
        toggleAgentBar() {
            this.showAgentBar = !this.showAgentBar;
        }
    }
}

</script>